
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.167 5.833v2.334H5.833V5.833h2.334zm1.166 0h2.917v2.334H9.333V5.833zM8.167 12.25H5.833V9.333h2.334v2.917zm1.166 0V9.333h2.917v2.334a.583.583 0 01-.583.583H9.333zM8.167 1.75v2.917H5.833V1.75h2.334zm1.166 0h2.334c.322 0 .583.261.583.583v2.334H9.333V1.75zM4.667 5.833v2.334H1.75V5.833h2.917zm0 6.417H2.333a.583.583 0 01-.583-.583V9.333h2.917v2.917zm0-10.5v2.917H1.75V2.333c0-.322.261-.583.583-.583h2.334z","fill":"#910000"}})])
          )
        }
      }
    